import type { AxiosPromise } from 'axios';
import BaseClient, { type ExtendedAxiosRequestConfig } from './BaseClient';
import type { CursorPaginationResponse } from './api';
import type {
    KioskTeamGroup,
    KioskTeamGroupSectionsParams,
    KioskTeamGroupSectionsResponse,
    KioskTeamGroupsCountParams,
    KioskTeamGroupsParams,
} from './adminTeamGroupsClient.types';

class AdminTeamGroupsClient extends BaseClient {
    getGroups(
        teamId: number,
        params?: KioskTeamGroupsParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<KioskTeamGroup>> {
        const url = `/api/admin/teams/${teamId}/groups`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getGroupsCount(
        teamId: number,
        params?: KioskTeamGroupsCountParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<{ count: number }> {
        const url = `/api/admin/teams/${teamId}/groups/count`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getGroupSections(
        teamId: number,
        params: KioskTeamGroupSectionsParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<KioskTeamGroupSectionsResponse> {
        const url = `/api/admin/teams/${teamId}/groups/sections`;
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }
}

export default new AdminTeamGroupsClient();
